import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`

export const TotalSleepTime = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: flex-end;
`

const Unit = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Hour = styled.div`
  display: flex;
  column-gap: 4px;
  align-items: flex-end;
`
export const HourValue = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 40px;
  color: ${props => props.theme.colors.color2d3139};
`
export const HourUnit = styled(Unit)``

export const Minute = styled.div`
  display: flex;
  column-gap: 4px;
  align-items: flex-end;
`

export const MinuteValue = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: ${props => props.theme.colors.color2d3139};
`
export const MinuteUnit = styled(Unit)``

export const PeriodInBed = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color2d3139};
`
